import { ReactNode } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEntityGraphStyles } from "./EntityGraph.styles";

export interface EntityGraphHeaderBarProps {
    title?: string;
    onClose?: () => void;
    children?: ReactNode;
}

// Slim workspace header modeled on DocumentPreviewHeader. The dialog replaces DotLegalDialog's built-in
// fullscreen header via setCustomHeader, so this bar carries the title, the graph controls and the close
// button in a single row and the canvas runs edge-to-edge below it.
function EntityGraphHeaderBar(props: EntityGraphHeaderBarProps) {
    const styles = useEntityGraphStyles();

    return (
        <Box sx={styles.headerBar}>
            {props.title && <Typography sx={styles.headerTitle}>{props.title}</Typography>}
            <Box sx={styles.headerControls}>{props.children}</Box>
            {props.onClose && (
                <IconButton size="small" sx={styles.headerClose} onClick={props.onClose}>
                    <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
            )}
        </Box>
    );
}

export default EntityGraphHeaderBar;
